import 'bootstrap/js/dist/collapse'
import { tns } from 'tiny-slider/src/tiny-slider.js'
// import jQuery from 'jquery'

const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('init common')

    // Remove no-js
    document.documentElement.className = 'js'

    // Test touch
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.classList.add('no-touch')
    } else {
      document.documentElement.classList.add('touch')
    }

    const offcanvas = document.querySelectorAll('.offcanvas')[0]
    const offcanvasClose = document.querySelectorAll('.offcanvas-close')[0]
    const offcanvasOpen = document.querySelectorAll('.nav-main-toggle-btn')[0]

    offcanvasClose.addEventListener('click', function (e) {
      offcanvas.classList.remove('is-open')
    })

    offcanvasOpen.addEventListener('click', function (e) {
      console.log('offcanvasOpen')
      offcanvas.classList.add('is-open')
    })

    const sliders = document.querySelectorAll('.tiny-slider')
    sliders.forEach((slider) => {
      tns({
        container: slider,
        items: 1.2,
        center: false,
        slideBy: 'page',
        autoplay: false,
        loop: false,
        controls: false,
        nav: false,
        mouseDrag: true,
        responsive: {
          780: {
            items: 3,
          },
        },
      })
    })

    const loader = document.getElementById('loader')

    function hideLoader() {
      loader.classList.add('hide')
    }

    function showLoader() {
      loader.classList.add('show')
    }

    if (!DEV) {
      showLoader()
      setTimeout(function () {
        hideLoader()
      }, 2000)

      window.addEventListener('load', function () {
        hideLoader()
      })
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize common')
  },
}
